import { render, staticRenderFns } from "./SmsReservation.vue?vue&type=template&id=6b636884&"
import script from "./SmsReservation.vue?vue&type=script&lang=ts&"
export * from "./SmsReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports